/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesDuplicateValuePolicy = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type WebApiModelsEnumerationTypesDuplicateValuePolicy = typeof WebApiModelsEnumerationTypesDuplicateValuePolicy[keyof typeof WebApiModelsEnumerationTypesDuplicateValuePolicy];


export function WebApiModelsEnumerationTypesDuplicateValuePolicyFromJSON(json: any): WebApiModelsEnumerationTypesDuplicateValuePolicy {
    return WebApiModelsEnumerationTypesDuplicateValuePolicyFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesDuplicateValuePolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesDuplicateValuePolicy {
    return json as WebApiModelsEnumerationTypesDuplicateValuePolicy;
}

export function WebApiModelsEnumerationTypesDuplicateValuePolicyToJSON(value?: WebApiModelsEnumerationTypesDuplicateValuePolicy | null): any {
    return value as any;
}

